const items = [
  "Ristrutturazioni Complete",
  "Bagni e Cucine",
  "Efficientamento Energetico",
  "Manutenzioni",
  "Chiavi in Mano",
  "Costruiamo il futuro, dalle fondamenta",
];

export const Marquee = () => (
  <div className="border-y border-white/10 bg-surface py-8 overflow-hidden" data-testid="editorial-marquee">
    <div className="marquee-track">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center gap-16 pr-16 shrink-0">
          <span className="font-display text-lg text-muted-foreground whitespace-nowrap">{item}</span>
          <img src="/star.png" alt="" className="h-5 w-auto shrink-0" loading="lazy" />
        </span>
      ))}
    </div>
  </div>
);
